import React from 'react';
import { SEND_INVITE } from '../../services/companies';
import { GET_ALL_PROFILES } from '../../services/profiles';
import { InputFieldTypes } from '../input_field';
import ModalForm from '../modal_form';

export default function Create({open = true, onClose, onSave}){
    const [formData, setFormData] = React.useState<any>(null);
    const [loadingSave, setLoadingSave] = React.useState(false);
    const [error, setError] = React.useState<any>(null);
    const [profiles, setProfiles] = React.useState<any[]>([]);

    const loadProfiles = () => {
        GET_ALL_PROFILES()
        .then(res => {
            setProfiles(res)
        })
        .catch(err => {})
    }
    
    const onConfirm = () => {
        setError(null)
        setLoadingSave(true)
        
        SEND_INVITE({...formData})
        .then(res => {
            setLoadingSave(false)
            onSave && onSave()
        })
        .catch(err => {
            setLoadingSave(false)
            setError(err.message)
        })
    }

    const COLUMNS = [
        {title: "E-mail", name: 'email', type: InputFieldTypes.STRING},
        {title: "Perfil", name: 'profile', type: InputFieldTypes.SELECT, options: profiles.map(p => ({label: p.title, value: p._id}))},
    ]

    React.useEffect(() => {
        setFormData(open ? {} : null)
    }, [open])

    React.useEffect(() => {
        loadProfiles()
    }, [])

    return <ModalForm
        title="Inserir usuário"
        columns={COLUMNS}
        loading={loadingSave}
        error={error}
        onChangeData={(dt) => setFormData(fd => ({...fd, ...dt}))}
        formData={formData}
        open={Boolean(formData)}
        onConfirm={onConfirm}
        onClose={onClose}
    />
}